export const ButtonVariantValues = {
  PRIMARY: 'primary',
  HERO: 'hero',
  SECONDARY: 'secondary',
  GHOST: 'ghost',
} as const;
export type ButtonVariant = (typeof ButtonVariantValues)[keyof typeof ButtonVariantValues];

export const ButtonTypeValues = {
  BUTTON: 'button',
  SUBMIT: 'submit',
  RESET: 'reset',
} as const;
export type ButtonType = (typeof ButtonTypeValues)[keyof typeof ButtonTypeValues];

export const ButtonTargetValues = {
  BLANK: '_blank',
  PARENT: '_parent',
  SELF: '_self',
  TOP: '_top',
} as const;
export type ButtonTarget = (typeof ButtonTargetValues)[keyof typeof ButtonTargetValues];

export type AllowedTags = "a" | "button";
